import TimelineContent from '@material-ui/lab/TimelineContent';

export default TimelineContent;
